import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider.jsx';

export function RequireRole({ allow, children }) {
  const { claims, loading } = useAuth();
  if (loading) return <div className="centered">Loading…</div>;
  const role = claims.role || 'member';
  if (!allow.includes(role)) return <Navigate to="/app" replace />;
  return children;
}
